export { DataAccessChip, type DataAccessChipProps } from "./DataAccessChip";
